import axios from '../../utils/axiosConfig';

// Action Types
export const FETCH_SUGGESTIONS_REQUEST = 'FETCH_SUGGESTIONS_REQUEST';
export const FETCH_SUGGESTIONS_SUCCESS = 'FETCH_SUGGESTIONS_SUCCESS';
export const FETCH_SUGGESTIONS_FAIL = 'FETCH_SUGGESTIONS_FAIL';

export const fetchSuggestions = (query, type) => async (dispatch) => {
  try {
    const response = await axios.get(
      `/search/suggestions?query=${query}&type=${type}`
    );

    // Extract suggestions array and ensure it's always an array
    const backendSuggestions = response.data.suggestions || [];

    if (type === 'brands') {
      // Convert backend response into proper structure for UI
      return backendSuggestions.map((keyword) => ({
        name: keyword,
        type: 'keyword',
      }));
    }

    return backendSuggestions; // Return empty array if nothing found
  } catch (error) {
    console.error('Error fetching suggestions:', error);
    return []; // Prevent undefined values
  }
};
